// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "monaco" + "." + "2a87ea3e" + ".chunk.css";
};